import { useCallback } from "react";

import { useStructuredSearchRefresh } from "@/components/StructuredSearch/hooks/useStructuredSearchRefresh";
import { ENDPOINTS } from "@/api/application-api";

export const useStructuredTracesRefresh = () => {
  const { clearNewDataBadge, advanceStructuredEndIfNeeded } = useStructuredSearchRefresh();

  const clearNewSpansBadge = useCallback(() => {
    clearNewDataBadge([ENDPOINTS.new_spans], { count_spans: 0 });
  }, [clearNewDataBadge]);

  return { clearNewSpansBadge, advanceStructuredEndIfNeeded };
};
